import { Component } from '@angular/core';
import { OAuthService, LoginOptions, ReceivedTokens } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
import { AppConfigService } from '../app-config.service';

@Component({
  selector: 'app-genesys-login',
  templateUrl: './genesys-login.component.html',
  styleUrls: ['./genesys-login.component.scss']
})
export class GenesysLoginComponent {
  constructor(private oAuthService: OAuthService, private router: Router, private appConfigService: AppConfigService) {
    this.oAuthService.configure(this.appConfigService.genesysAuthConfig);
    const options = new LoginOptions();
    options.disableNonceCheck = true;
    options.onTokenReceived = this.handleTokenReceived;
    this.oAuthService.tryLogin(options);
  }
  private handleTokenReceived = (receivedToken: ReceivedTokens) => {
    if (receivedToken.state) {
      const decodedState = decodeURIComponent(receivedToken.state);
      this.router.navigateByUrl(decodedState);
    } else if (typeof window !== 'undefined' && window.opener == null) {
      this.router.navigateByUrl('/dial');
    }
  }
}
